import { Box } from '@chakra-ui/react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { z } from 'zod';

import { ApproveFundingRequest } from 'capitalProvider/domains/fundingRequests/ui/ApproveFundingRequestContainer';
import { dashboardRoutePadding } from 'packages/common-frontend/constants';

// Types
const RouteParamsStruct = z.object({
  fundingRequestId: z.string({ message: 'Missing URL parameter' }),
});

// Exports
export const FundingRequestApproveRoute = () => {
  const params = useParams();
  const { fundingRequestId } = RouteParamsStruct.parse(params);

  return (
    <Box padding={dashboardRoutePadding}>
      <ApproveFundingRequest fundingRequestId={fundingRequestId} />
    </Box>
  );
};
